/**
 * Type: ユーティリティーパーツ
 * What: 文字省略
 */

const TruncateFunc = (str, len) => (str.length <= len ? str : `${str.substr(0, len)}...`);

export default TruncateFunc;
